import React from 'react'
import './index.css'

import Header from './header'

export default ({ children, showHeader = true, className }) => {
    return (
        <div className={`layout ${className}`}>
            {showHeader && <Header />}
            <div className="layout-content">
                {children}
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/layout/index.js